import { useTranslation } from 'react-i18next';

export default function EmergencyContactSection({ data, onChange, lang }) {

    const { t } = useTranslation();

    return (
        <>

            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Contacto de emergencia")}</h2>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="fullname" className="u-form-control-hidden u-label">{t("Nombre y apellidos")}</label>
                <input
                    type="text"
                    placeholder={t("Nombre y apellidos")}
                    id="fullname"
                    name="fullName"
                    value={data.fullName}
                    onChange={onChange}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="phone" className="u-form-control-hidden u-label">{t("Teléfono")}</label>
                <input
                    type="text"
                    placeholder={t("Teléfono")}
                    name="phone"
                    id="phone"
                    value={data.phone}
                    onChange={onChange}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="mobile" className="u-form-control-hidden u-label">{t("Móvil")}</label>
                <input
                    type="text"
                    placeholder={t("Móvil")}
                    name="mobile"
                    id="mobile"
                    value={data.mobile}
                    onChange={onChange}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="email" className="u-form-control-hidden u-label">{t("Correo electrónico")}</label>
                <input
                    type="email"
                    placeholder={t("Correo electrónico")}
                    name="email"
                    id="email"
                    value={data.email}
                    onChange={onChange}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

        </>
    );
}
